export const LINK_TYPE_MOBILE_CUSTOM = 'custom';
export const LINK_TYPE_MOBILE_PARTNER = 'partner';
export const LINK_TYPE_MOBILE_WEB_TO_APP = 'mobile_web_to_app';
export const LINK_TYPE_LEGACY = 'legacy';
